<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <div>
        <h2>{{ title }}</h2>
        <p>按日期与分部查询，页面结果与导出条件保持一致</p>
      </div>
      <el-button
        type="primary"
        :loading="exporting"
        @click="download"
      >
        导出 Excel
      </el-button>
    </div>
    <el-card shadow="never">
      <el-form inline>
        <el-form-item label="日期范围">
          <el-date-picker
            v-model="dates"
            type="daterange"
            value-format="YYYY-MM-DD"
          />
        </el-form-item>
        <el-form-item label="分部">
          <el-select
            v-model="branchId"
            clearable
            style="width: 180px"
          >
            <el-option
              v-for="b in branches"
              :key="b.id"
              :label="b.name"
              :value="b.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="load"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="loading"
        :data="rows"
        stripe
      >
        <el-table-column
          v-for="col in columns"
          :key="col"
          :prop="col"
          :label="labels[col] || col"
          min-width="135"
        >
          <template #default="{ row }">
            <span v-if="isAmount(col)">¥ {{ money(row[col]) }}</span>
            <span v-else>{{ row[col] ?? '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-empty
        v-if="!loading && !rows.length"
        description="当前条件暂无数据"
      />
    </el-card>
  </div>
</template>
<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import { organizationApi, reportApi } from '../api'
const route = useRoute(),
  rows = ref([]),
  branches = ref([]),
  dates = ref([]),
  branchId = ref(),
  loading = ref(false),
  exporting = ref(false)
const type = computed(() => route.meta.reportType || 'company')
const title = computed(() => route.meta.title || '经营报表')
const columns = computed(() =>
  rows.value.length ? Object.keys(rows.value[0]) : []
)
const labels = {
  id: '编号',
  user_id: '员工编号',
  user_name: '员工',
  team_id: '小组编号',
  team_name: '小组',
  leader_name: '组长',
  branch_id: '分部编号',
  branch_name: '分部',
  customer_name: '客户',
  housing_number: '房源编号',
  item_count: '笔数',
  transaction_count: '成交笔数',
  performance_amount: '业绩',
  payable_amount: '应发',
  paid_amount: '已发',
  remaining_amount: '未发',
  bonus_amount: '奖金',
  receivable: '应收',
  receivable_amount: '应收',
  received_amount: '已收',
  outstanding_amount: '未收',
  personal_payable: '个人应发',
  company_pool: '公司分成',
  branch_retention: '分部留存',
  other_income: '其他收入',
  expense: '支出',
  profit: '利润',
  accrual_profit: '应计利润',
  cash_in: '现金流入',
  cash_out: '现金流出',
  cash_net: '现金净额',
  period_in: '期间流入',
  period_out: '期间流出',
  balance: '余额',
  opening_balance: '期初余额',
  biz_date: '业务日期',
  biz_type: '业务类型',
  direction: '方向',
  summary: '摘要',
  age_days: '账龄天数',
  transaction_id: '成交编号',
  tran_point: '成交地点',
  account_name: '账户',
  name: '名称',
  type: '类型',
  status: '状态',
  created_at: '创建时间',
  confirmed_at: '确认时间',
}
const isAmount = (k) =>
  /(amount|income|expense|profit|pool|retention|balance|cash_|period_)/.test(k)
const money = (v) =>
  Number(v || 0).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
const params = () => ({
  startDate: dates.value?.[0],
  endDate: dates.value?.[1],
  branchId: branchId.value,
})
const load = async () => {
  loading.value = true
  try {
    rows.value = (await reportApi.report(type.value, params())) || []
  } catch (e) {
    ElMessage.error(e?.message || '报表加载失败')
  } finally {
    loading.value = false
  }
}
const download = async () => {
  exporting.value = true
  try {
    const blob = await reportApi.export(type.value, params())
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `${title.value}.xlsx`
    a.click()
    URL.revokeObjectURL(url)
  } catch (e) {
    ElMessage.error(e?.message || '导出失败')
  } finally {
    exporting.value = false
  }
}
watch(type, load)
onMounted(async () => {
  const now = new Date(),
    start = new Date(now.getFullYear(), now.getMonth(), 1)
  dates.value = [
    start.toISOString().slice(0, 10),
    now.toISOString().slice(0, 10),
  ]
  try {
    branches.value = (await organizationApi.branches()) || []
  } catch (e) {
    ElMessage.warning(e?.message || '分部资料加载失败')
  }
  await load()
})
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8492a6;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
</style>
